import { render, staticRenderFns } from "./addbanner.vue?vue&type=template&id=5fe0e056&scoped=true&"
import script from "./addbanner.vue?vue&type=script&lang=js&"
export * from "./addbanner.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./addbanner.vue?vue&type=style&index=1&id=5fe0e056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0e056",
  null
  
)

export default component.exports